import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';

import { Grid, TextField } from '@material-ui/core';

import MyAutoComplete from '../utils/MyAutoComplete';
import UnoButton from '../utils/UnoButton';

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: theme.spacing(4),
    },
    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        }
    },
}));

export default function SelectAlmBenchmarkModal(props) {

    const classes = useStyles();

    const { open, allBenchmarks, currentBenchmarkIds, handleAction } = props;

    const [submitted, setSubmitted] = useState(false);
    const [benchmarkSelected, setBenchmarkSelected] = useState(null);

    const availableBenchmarks = allBenchmarks
        ? allBenchmarks.filter(b => !currentBenchmarkIds.includes(b.id))
        : [];

    const handleConfirm = () => {
        setSubmitted(true);
        if (benchmarkSelected && !currentBenchmarkIds.includes(benchmarkSelected.id)) {
            handleAction(benchmarkSelected);
        }
    }

    useEffect(() => {

        if (!open) {
            setBenchmarkSelected(null);
            setSubmitted(false);
        }

    }, [open])

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            onClose={() => handleAction(false)}>

            <DialogTitle className={classes.dialogTitle}>
                {"Adicionar benchmark"}
            </DialogTitle>

            <DialogContent className={classes.contentModal}>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <MyAutoComplete
                            outerlabel={"Benchmark"}
                            onChange={(event, newValue) => setBenchmarkSelected(newValue)}
                            options={availableBenchmarks}
                            autoComplete
                            label={'Nome do benchmark'}
                            value={benchmarkSelected ? benchmarkSelected : null}
                            getOptionLabel={(option) => option.name}
                            validator={benchmarkSelected == null && submitted ? true : false}
                            helperText={"Informe o benchmark"}
                            renderOption={(option) => (
                                <React.Fragment key={'select-alm-benchmark-' + option.id}>
                                    <span>{option.name}</span>
                                </React.Fragment>
                            )}
                            renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                        />
                    </Grid>
                </Grid>

            </DialogContent>

            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() => handleAction(false)} color="secondary">
                    {'Cancelar'}
                </UnoButton>

                <UnoButton onClick={() => handleConfirm()} color="primary">
                    {"Confirmar"}
                </UnoButton>

            </DialogActions>

        </Dialog>
    );
}
